import { Container } from 'pixi.js';
import { Spine } from '../spine';
import { iconStates, slotSpineKey, specialIconKeys } from '../../../constants/symbolsNames';

// RU: рамка выигрышного символа — отдельный спайн под самим символом.
const WIN_BORDER_ANIMATION = 'winFrame';
const WIN_BORDER_SCALE = 0.95;
const WIN_BORDER_OFFSET = { x: 2, y: -1 };

export class SlotIcon extends Container {
  constructor({ parent, styles, winParent, reelIndex, rowIndex, key }) {
    super();
    this.position.set(styles.x, styles.y);
    parent.addChild(this);
    this.animationType = 'slotIcon';
    this.winParent = winParent;
    this.spinParent = parent;
    this.reelIndex = reelIndex;
    this.rowIndex = rowIndex;
    this.key = key;
    this.iconWinBoard = this.addChild(new Spine({ key: slotSpineKey.winSymbolBorder }));
    this.iconWinBoard.visible = false;
    this.iconWinBoard.scale.set(WIN_BORDER_SCALE);
    this.iconWinBoard.position.set(WIN_BORDER_OFFSET.x, WIN_BORDER_OFFSET.y);
    this.icon = this.addChild(new Spine({ key }));
    this.iconNumber = key;
    this.currentState = null;
    this.changeState(iconStates.idle);
    this.xPosInReel = this.x;
    this.yPosInReel = this.y;
    this.yPosInWin = this.y;
    this.xPosInWin = this.x;
  }

  setWinContainerPositions(positions) {
    this.xPosInWin = positions.xInWin;
    this.yPosInWin = positions.yInWin;
  }

  // RU: состояние применяется ВСЕГДА, и при том же номере: ранний выход прежде выбрасывал его,
  //     и символ, которому прокрутка выдала тот же номер, оставался в позе прошлого раунда
  //     (win/noWin) вместо blur. Третий аргумент прежде назывался timeScale, а уходил в loop.
  changeIcon(newNumber, state = iconStates.idle, timeScale = 1) {
    if (newNumber !== this.iconNumber) {
      this.iconNumber = newNumber;
      this.key = newNumber;
      this.icon.show();
      this.icon.changeTexture(this.iconNumber?.toString());
    }
    this.changeState(state, timeScale);
  }

  // RU: обещания здесь нет намеренно: прежде каждый вызов вешал на AnimationState слушатель
  //     ради промиса, которого никто не ждал, и тут же снимал ВСЕХ слушателей спайна
  //     (`clearListeners`). Кому нужен конец анимации, вешает одноразовый `onceAnimationEvent`.
  //     По кругу идёт только idle у wild — как и было в игре.
  changeState(state, timeScale = 1) {
    this.currentState = state;
    this.icon.stop();
    this.changeToActualParent();
    const loop = state === iconStates.idle && this.iconNumber === specialIconKeys.wild;
    this.icon.play(state, loop, timeScale);
    if (state === iconStates.win) {
      this.iconWinBoard.play(WIN_BORDER_ANIMATION, true);
      this.iconWinBoard.visible = true;
    } else {
      this.iconWinBoard.visible = false;
    }
  }

  changeToActualParent() {
    const parent = this.currentState === iconStates.win ? this.winParent : this.spinParent;
    if (parent !== this.parent) {
      if (parent === this.spinParent) {
        this.x = this.xPosInReel;
        this.y = this.yPosInReel;
      }
      if (parent === this.winParent) {
        this.x = this.xPosInWin;
        this.y = this.yPosInWin;
      }
      parent.addChild(this);
    }
  }
}
